import React from "react";
import "./desktop-odpoledni_nabidka.css";
import NavbarDesktop from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

function NapojovyListek() {
  return (
    <div className="desktop-novy-jidelni-listek-root">
      <Helmet>
        <title>Odpolední nabídka | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Odpolední menu pro pohodové posezení – lehčí jídla, domácí dezerty, výběrová káva a něco malého na chuť. Přijďte si užít klidnou atmosféru."
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="odpolední nabídka, posezení, dezerty, lehká jídla, káva, něco malého, hospůdka, Zlín, Beskydy"
        />
        <meta name="author" content="GAMPERIOS s.r.o." />
        <meta property="og:title" content="Odpolední nabídka | Hospůdka pod Rablinů" />
        <meta
          property="og:description"
          content="Přijďte si odpočinout u odpolední nabídky. Káva, zákusky, něco na zub a domácí atmosféra v srdci přírody."
        />
        <meta
          property="og:image"
          content="https://www.hospudkapodrablinu.cz/img/hospudka-pod-rablinu-main-foto-1.jpg"
        />
        <meta property="og:url" content="https://www.hospudkapodrablinu.cz/odpoledni-nabidka" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Hospůdka pod Rablinů" />
        <meta property="og:locale" content="cs_CZ" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Odpolední nabídka | Hospůdka pod Rablinů" />
        <meta
          name="twitter:description"
          content="Dejte si něco sladkého nebo lehkého během odpoledne. Odpočiňte si u kávy v naší hospůdce."
        />
        <meta
          name="twitter:image"
          content="https://www.hospudkapodrablinu.cz/img/hospudka-pod-rablinu-main-foto-1.jpg"
        />
      </Helmet>

      <div className="desktop-novy-jidelni-listek-navbar">
        <NavbarDesktop />
      </div>

      {/* SPACER – odsune obsah pod pevný/sticky navbar */}
      <div className="desktop-novy-jidelni-listek-nav-spacer" aria-hidden="true" />

      {/* Hlavní záhlaví */}
      <header className="desktop-novy-jidelni-listek-hero">
        <h3 className="desktop-novy-jidelni-listek-hlavni-nadpis-1">
          ODPOLEDNÍ NABÍDKA
        </h3>
      </header>

      {/* Info banner SO–NE */}
      <div
        className="desktop-novy-jidelni-listek-info"
        role="note"
        aria-label="Informace k rozšířenému lístku"
      >
        Tento rozšířený lístek platí <strong>SO – NE</strong> od{" "}
        <strong>11:00</strong> do <strong>15:00</strong>
      </div>

      {/* Obsah jídelníčku */}
      <main className="desktop-novy-jidelni-listek-wrapper">
        <section className="desktop-novy-jidelni-listek-sekce">
          <h2 className="desktop-novy-jidelni-listek-sekce-nadpis">Polévky</h2>
          <p className="desktop-novy-jidelni-listek-polozka">
            0,5l Valašská kyselice s pravými hříbky a klobásou
          </p>
          <p className="desktop-novy-jidelni-listek-polozka">
            0,5l Hovězí vývar s kořenovou zeleninou, játrovými knedlíčky a nudlemi
          </p>
        </section>

        <section className="desktop-novy-jidelni-listek-sekce">
          <h2 className="desktop-novy-jidelni-listek-sekce-nadpis">Hlavní chody</h2>
          <p className="desktop-novy-jidelni-listek-polozka">200g Špalíček z vepřové panenky</p>
          <p className="desktop-novy-jidelni-listek-polozka">200g Grilovaný prsní kuřecí steak</p>
          <p className="desktop-novy-jidelni-listek-polozka">200g Steak z mladého býčka z Kašavského údolí BIO</p>
          <p className="desktop-novy-jidelni-listek-polozka">200g Filírovaná kuřecí prsíčka s bylinkovým pestem a parmezánem</p>
          <p className="desktop-novy-jidelni-listek-polozka">180g Kuřecí prsíčka plněná mozzarellou a sušenými rajčaty</p>
          <p className="desktop-novy-jidelni-listek-polozka">400g Velký Vídeňský řízek (z vepřové panenky pomalu smažený na sádle)</p>
          <p className="desktop-novy-jidelni-listek-polozka">200g Malý Vídeňský řízek (z vepřové panenky pomalu smažený na sádle)</p>
          <p className="desktop-novy-jidelni-listek-polozka">150g Smažená kuřecí prsíčka</p>
          <p className="desktop-novy-jidelni-listek-polozka">100g Smažený hermelín</p>
          <p className="desktop-novy-jidelni-listek-polozka">120g Smažený eidam</p>
          <p className="desktop-novy-jidelni-listek-polozka">180g Smažená kuřecí prsíčka plněná tvarůžky a domácí slaninou</p>
          <p className="desktop-novy-jidelni-listek-polozka">150g Myslivecký guláš, chléb, cibule</p>
          <p className="desktop-novy-jidelni-listek-polozka">400g Pomalu pečená medová žebírka na černém pivu a chléb</p>
          <p className="desktop-novy-jidelni-listek-polozka">450g Valašský knedlík (plněný borůvkami se zakysanou smetanou a borůvkovým dipem)</p>
        </section>

        <section className="desktop-novy-jidelni-listek-sekce">
          <h2 className="desktop-novy-jidelni-listek-sekce-nadpis">Pro malý hlad</h2>
          <p className="desktop-novy-jidelni-listek-polozka">220g Domácí libová tlačenka v patentní sklenici, pečivo</p>
          <p className="desktop-novy-jidelni-listek-polozka">70g Husí Paštika, brusinky a pečivo</p>
          <p className="desktop-novy-jidelni-listek-polozka">120g Tatarák z mladého býčka z Kašavského údolí BIO (4ks topinky)</p>
        </section>

        <section className="desktop-novy-jidelni-listek-sekce">
          <h2 className="desktop-novy-jidelni-listek-sekce-nadpis">Přílohy</h2>
          <p className="desktop-novy-jidelni-listek-polozka">150g Hranolky</p>
          <p className="desktop-novy-jidelni-listek-polozka">200g Vařené brambory s máslem</p>
          <p className="desktop-novy-jidelni-listek-polozka">200g Rozmarýnové brambory</p>
          <p className="desktop-novy-jidelni-listek-polozka">200g Bramborový salát</p>
          <p className="desktop-novy-jidelni-listek-polozka">250g Grilovaná zelenina</p>
        </section>
      </main>

      <div className="desktop-novy-jidelni-listek-footer">
        <Footer />
      </div>
    </div>
  );
}

export default NapojovyListek;